export const HOME_VIDEO_WARM_BATCH_SIZE = 2;
export const HOME_VIDEO_WARM_BATCH_DELAY_MS = 1500;

type NetworkInformationLike = {
  saveData?: boolean;
  effectiveType?: string;
};

type NavigatorWithConnection = Navigator & {
  connection?: NetworkInformationLike;
};

export function getNavigatorNetworkConnection():
  | NetworkInformationLike
  | undefined {
  return (navigator as NavigatorWithConnection).connection;
}

export function shouldSkipHomeVideoCacheWarm(
  connection: NetworkInformationLike | undefined
): boolean {
  if (!connection) {
    return false;
  }
  if (connection.saveData) {
    return true;
  }
  const type = connection.effectiveType;
  return type === "slow-2g" || type === "2g";
}

export async function prefetchHomeVideosInBatches(
  urls: readonly string[],
  options?: {
    fetchFn?: typeof fetch;
    batchSize?: number;
    batchDelayMs?: number;
  }
): Promise<void> {
  const fetchFn = options?.fetchFn ?? fetch;
  const batchSize = options?.batchSize ?? HOME_VIDEO_WARM_BATCH_SIZE;
  const batchDelayMs = options?.batchDelayMs ?? HOME_VIDEO_WARM_BATCH_DELAY_MS;

  for (let index = 0; index < urls.length; index += batchSize) {
    const batch = urls.slice(index, index + batchSize);
    await Promise.allSettled(
      batch.map((url) => fetchFn(url, { mode: "cors", credentials: "omit" }))
    );
    if (index + batchSize < urls.length) {
      await new Promise((resolve) => setTimeout(resolve, batchDelayMs));
    }
  }
}
